'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.instructions = exports.description = exports.ContentModel = exports.ContentModels = undefined;

var _contentmodel = require('./contentmodel');

var exampleContentModels = _interopRequireWildcard(_contentmodel);

require('./style.css');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var ContentModels = exports.ContentModels = exampleContentModels;
var ContentModel = exports.ContentModel = exampleContentModels.default;

var description = exports.description = "This is the example-activity.";
var instructions = exports.instructions = '\nThese are the example-activity installation instructions:\n  Step 1...\n  Step 2...\n  Step 3...\n';


//////////////////
// WEBPACK FOOTER
// ./~/trc-example-activity/dist/index.js
// module id = ./node_modules/trc-example-activity/dist/index.js
// module chunks = 0